import { makeStyles } from '@material-ui/core/styles'

import {
  black,
  grayMelange,
  lightergray2,
  lightergray3,
  lightGray,
  lightOrange,
  lightOrange2,
  normalGray,
  orange,
  red,
  white,
} from '../../constants/colorConstants'

export default makeStyles((theme) => ({
  firstColumn: {
    marginRight: '32px',
    marginLeft: '8px',
    fontSize: '14px',
    lineHeight: '16.41px',
    ...theme.mundi.font.roboto400Normal,
    width: '46%',
  },
  secondColumn: {
    marginRight: '0px',
    marginLeft: '0px',
    fontSize: '14px',
    lineHeight: '16.41px',
    ...theme.mundi.font.roboto400Normal,
    width: '46%',
  },
  firstColumnDate: {
    marginRight: '32px',
    marginLeft: '8px',
    marginBottom: '18px',
    fontSize: '14px',
    lineHeight: '16.41px',
    ...theme.mundi.font.roboto400Normal,
    width: '46%',
  },
  secondColumnDate: {
    marginRight: '0px',
    marginLeft: '0px',
    marginBottom: '18px',
    fontSize: '14px',
    lineHeight: '16.41px',
    ...theme.mundi.font.roboto400Normal,
    width: '46%',
  },
  title: {
    fontSize: '24px',
    lineHeight: '28.8px',
    ...theme.mundi.font.lato800Normal,
  },
  subtitle: {
    fontSize: '16px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto400Normal,
    marginTop: '18px',
  },
  toolbarRight: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'transparent!important',
    justifyContent: 'flex-end',
  },
  toolbarSpaceBetween: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'transparent!important',
    justifyContent: 'space-between',
  },
  button: {
    backgroundColor: orange,
    border: `solid 1px ${orange}!important`,
    padding: '10px 20px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: white,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginBottom: '30px',
    marginRight: '5px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: orange,
    },
    cursor: 'pointer',
  },
  buttonClose: {
    backgroundColor: orange,
    border: `solid 1px ${orange}!important`,
    padding: '10px 20px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: white,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginRight: '5px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: orange,
    },
    cursor: 'pointer',
  },
  buttonDisabled: {
    backgroundColor: lightergray2,
    border: `solid 1px ${lightergray2}!important`,
    padding: '10px 20px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: lightGray,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginBottom: '30px',
    marginRight: '5px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: lightergray3,
    },
    cursor: 'none!important',
  },
  secondaryButton: {
    backgroundColor: white,
    border: `solid 1px ${orange}!important`,
    padding: '10px 20px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: orange,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginRight: '5px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: lightOrange,
    },
    cursor: 'pointer',
  },
  secondaryButtonNoBorder: {
    backgroundColor: white,
    padding: '10px 20px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: orange,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginRight: '5px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: lightOrange,
    },
    cursor: 'pointer',
  },
  secondaryButtonNoBorderDisabled: {
    backgroundColor: white,
    padding: '10px 20px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: lightGray,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginRight: '5px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: lightGray,
    },
    cursor: 'none!important',
  },
  secondaryButtonDisabled: {
    backgroundColor: white,
    border: `solid 1px ${lightGray}!important`,
    padding: '10px 20px',
    borderRadius: '28px',
    ...theme.mundi.font.roboto400Normal,
    color: lightGray,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginRight: '5px',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: white,
    },
    cursor: 'none!important',
  },
  link: {
    ...theme.mundi.font.roboto400Normal,
    color: black,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginBottom: '31px',
    marginRight: '5px',
    cursor: 'pointer',
  },
  linkDisabled: {
    ...theme.mundi.font.roboto400Normal,
    color: black,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginBottom: '31px',
    marginRight: '5px',
    cursor: 'default',
  },
  errorMessage: {
    ...theme.mundi.font.roboto400Normal,
    color: red,
    fontSize: '13px',
    lineHeight: '15.23px',
    marginBottom: '31px',
    marginRight: '24px',
    width: '100%',
  },
  resultDescription: {
    fontSize: '13px',
    lineHeight: '22px',
    ...theme.mundi.font.roboto500Normal,
    color: grayMelange,
    marginLeft: '10px',
    marginRight: '10px',
  },
  sign: {
    fontSize: '13px',
    lineHeight: '22px',
    ...theme.mundi.font.roboto500Normal,
    marginTop: '11px',
    color: orange,
    marginLeft: '10px',
  },
  requestedDocumentation: {
    fontSize: '16px',
    lineHeight: '22px',
    ...theme.mundi.font.roboto700Normal,
    color: orange,
    marginLeft: '7px',
  },
  requestedDocumentationRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginLeft: '10px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '12px',
  },
  row315: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '12px',
    width: '315px',
  },
  document: {
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto400Normal,
  },
  required: {
    fontSize: '11px',
    lineHeight: '12.89px',
    ...theme.mundi.font.roboto400Normal,
    color: normalGray,
    marginLeft: '4px',
  },
  documentList: {
    listStyleType: 'none',
    marginBottom: '5x',
    width: '50%',
    marginLeft: '-3px',
    marginTop: '5px',
  },
  documentsPanel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  sea: {
    fontSize: '13px',
    lineHeight: '15.23px',
    ...theme.mundi.font.roboto600Normal,
  },
  nohover: {
    '&:hover': {
      backgroundColor: 'transparent!important',
    },
  },
  hiddenField: {
    width: '1px',
    height: '1px',
    display: 'none',
  },
  invisible: {
    display: 'none',
  },
  chip: {
    color: orange,
    border: `solid 1px ${orange}`,
    marginRight: '10px',
  },
  filesPanel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    paddingLeft: '35px',
  },
  buttonUpload: {
    marginLeft: '35px',
    color: orange,
    borderColor: lightOrange2,
    backgroundColor: white,
    padding: '5px 15px',
    borderRadius: '4px',
    textTransform: 'uppercase',
    '&:hover': {
      borderColor: orange,
      backgroundColor: lightOrange,
    },
  },
  invoiceSummaryList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    maxHeight: '450px',
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'relative',
    marginTop: '-25px',
  },
  invoiceSummary: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    marginLeft: '7px',
    marginRight: '10px',
    marginTop: '10px',
    marginBottom: '10px',
    padding: '10px',
    borderRadius: '8px',
    border: `solid 1px ${lightGray}`,
  },
  invoiceSummaryLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  invoiceSummaryField: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  invoiceSummaryFieldName: {
    fontSize: '13px',
    lineHeight: '22px',
    ...theme.mundi.font.roboto500Normal,
    color: grayMelange,
    paddingRight: '10px',
  },
  invoiceSummaryFieldValue: {
    fontSize: '13px',
    lineHeight: '22px',
    ...theme.mundi.font.roboto400Normal,
    color: normalGray,
    paddingRight: '10px',
  },
  invoiceSummaryTitleLine: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  invoiceSummaryTitle: {
    fontSize: '15px',
    lineHeight: '22px',
    ...theme.mundi.font.roboto700Normal,
    color: grayMelange,
    paddingBottom: '5px',
  },
  invoiceButton: {
    marginRight: '-25px',
  },
  invoiceSummaryFooter: {
    minHeight: '50px',
  },
  amountColumn: {
    '& .MuiInputAdornment-root': {
      pointerEvents: 'none',
    },
  },
}))
